import React, { use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { ReportContextType } from "./reportContext.types";
import type { ReportInfo } from "../../../../../../api/types/svTypes.ts";

export const ReportsContext = React.createContext<ReportContextType<ReportInfo> | undefined>(undefined);

export function useReportsContext<T extends ReportInfo>() {
  const context = use(ReportsContext);
  return defined(context as unknown as ReportContextType<T>);
}
